/** Converts an enum value like "end_of_project_survey" into "End Of Project Survey" for display */
export const formatEnumLabel = (value: string) =>
  value
    .split('_')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
